
    export const BuildCommit = '323b9f9042a644faedc74a7cc88dee45fd84763a';
    export const BuildVersion = '3.0.2';
